import { Component, OnInit , Input, AfterViewInit} from '@angular/core';
import AOS from 'aos';
import { CommonModule } from "@angular/common";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators,FormArray,FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { ApiService } from "src/app/service/api.service";
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-home1',
  templateUrl: './home1.component.html',
  styleUrls: ['./home1.component.css']
})
export class Home1Component implements OnInit,AfterViewInit {

   constructor(private http: HttpClient,public api:ApiService,private notification : NotificationService,private snackBar: MatSnackBar) { }
 

  ngAfterViewInit() {
    window.addEventListener('scroll', () => {
      AOS.refresh();
    });
    }

  ngOnInit() {
    this.createCaptcha()
    AOS.init({
      duration: 1500, // Animation duration (in milliseconds)
      easing: 'ease-in-out', // Animation style
      once: false, // If false, animation happens every time element enters viewport
      mirror: true // If true, animation occurs on scroll up as well
    });
  }

  RegisterForm = new FormGroup({
      id:new FormControl(''),
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      mobile: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$'), // Ensures exactly 10 digits, no characters
        ]),
      subject: new FormControl(''),
      message: new FormControl(''),
      capicha: new FormControl('', [this.validateCaptcha.bind(this)]),
      status: new FormControl(),
      });



  cards = [
    {
      title: "Welcome to Soul Space",
      description: "Soul Space is a sanctuary, where your wellness is our priority. At Soul Space, we believe that the harmony ...",
      link: "/welcome-soul-space",
      colorClass: "3"
    },
    {
      title: "Our Mission",
      description: "Soul Space Wellness & Behavioural Health Clinic is dedicated to promoting holistic well-being...",
      link: "/about-single-page",
      colorClass: "2"
    },
    {
      title: "Our Vision",
      description: "We envision a world where individuals have access to supportive and integrative care that nurture...",
      link: "/about-single-page",
      colorClass: "4"
    } 
    // {
    //   title: "Who Are We",
    //   description: "Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.",
    //   link: "/who-r-v",
    //   colorClass: "4"
    // },
    // {
    //   title: "Why Choose Soul Space",
    //   description: "<ul class='centered-list'> <li>Personalized Care from experienced professionals.</li> <li>Perfect blend of modern scientific treatments that are clinically proven.</li> <li>Holistic Wellbeing - Mind, Body & Soul.</li> </ul>",
    //   link: "/why-choose-ss",
    //   colorClass: "5"
    // },
    // {
    //   title: "Embracing Mental Wellbeing in a Changing World",
    //   description: "The rapid technological advances of recent decades have profoundly impacted our individual and collective lifestyles. These changes necessitate a restructuring of our belief systems, urging us to place mental and emotional wellbeing on par with physical health, rather than viewing it as a distant corollary of “good physical health”.",
    //   link: "/mental-wellbeing",
    //   colorClass: "6"
    // }
  ];

  isContactFormOpen = true; // Ensure the form is initially visible

  closeContactForm() {
    this.isContactFormOpen = false; // Hides the contact form when close button is clicked
  }

  validateCaptcha(control: FormControl) {
		if (control.value && control.value.toUpperCase() !== this.resultCode) {
		  return { invalidCaptcha: true };
		}
		return null;
	  }

	  get capicha() {
		return this.RegisterForm.get('capicha');
	  }


	onSubmit() {
		console.log('this.RegisterForm', this.RegisterForm);

    if (this.capicha.errors) {
			this.snackBar.open('Invalid CAPTCHA. Please try again.', 'Close', {
			  duration: 4000,
			  panelClass: ['error-snackbar'],
			});
			return;
		  }


		  if (this.RegisterForm.invalid) {
			this.RegisterForm.markAllAsTouched();
			return;
		}
	  
		if (this.RegisterForm.valid) {

			if (!this.RegisterForm.value.subject) {
        this.RegisterForm.value.subject = null;
    }

		this.RegisterForm.value.status = 1;
		  this.api
			.postAPI(
			  environment.API_URL + "master/contact/crud",
			  this.RegisterForm.value
			)
			.subscribe(
			  (res) => {
				if (res.status === 1) {
				  this.snackBar.open(res.message, 'Close', {
					duration: 100, 
					horizontalPosition: 'center',
					verticalPosition: 'bottom',
					panelClass: ['success-snackbar'], 
				  });
				  this.RegisterForm.reset();
				} else if (res.status === 2) {
				  this.snackBar.open(res.message, 'Close', {
					duration: 100, 
					horizontalPosition: 'center',
					verticalPosition: 'bottom',
					panelClass: ['error-snackbar'], 
				  });
				}
			  },
			  (error) => {
				this.snackBar.open('An error occurred!', 'Close', {
				  duration: 100,
				  horizontalPosition: 'center',
				  verticalPosition: 'bottom',
				  panelClass: ['error-snackbar'],
				});
			  }
			);
		}
	  }

      @Input("config") config: any = {
        type: 1,
        length: 6,
        cssClass: "custom",
        back: {
          stroke: "#2F9688",
          solid: "#f2efd2",
        },
        font: {
          color: "#000000",
          size: "35px",
        },
      };

    captch_input: any = null;
    code: any = null;
    resultCode: any = null;
    checkCaptchaValue: boolean = false;

    checkCaptcha() {
      if (this.captch_input === this.resultCode) {
  
        this.checkCaptchaValue = true;
        return true;
      } else {
        this.checkCaptchaValue = false;
        return false;
      }
    
    }
  
    createCaptcha() {
      switch (this.config.type) {
        case 1:
          let char =
            Math.random()
              .toString(24)
              .substring(2, this.config.length) +
            Math.random().toString(24).substring(2, 4);
          this.code = this.resultCode = char.toUpperCase();
          break;
        case 2: 
      
      }
      setTimeout(() => {
        let captcahCanvas: any = document.getElementById("captcahCanvas");
        var ctx = captcahCanvas.getContext("2d");
        ctx.fillStyle = this.config.back.solid;
        ctx.fillRect(0, 0, captcahCanvas.width, captcahCanvas.height);
  
        ctx.beginPath();
  
        captcahCanvas.style.letterSpacing = 10 + "px";
        captcahCanvas.style.height = 95 + "px";
        ctx.font = this.config.font.size + " " + this.config.font.family;
        ctx.fillStyle = this.config.font.color;
        ctx.textBaseline = "middle";
        ctx.fillText(this.code, 50, 80);
        if (this.config.back.stroke) {
          ctx.strokeStyle = this.config.back.stroke;
          for (var i = 0; i < 150; i++) {
            ctx.moveTo(Math.random() * 300, Math.random() * 300);
            ctx.lineTo(Math.random() * 300, Math.random() * 300);
          }
          ctx.stroke();
        }
  
      }, 100);
    }
  
    reloadCaptcha(): void {
      this.createCaptcha();
    }

  
}
  

